import { applicationApi } from 'common/api';
import { Umkm, UmkmCategory } from 'models/umkm';

export const umkmApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getUmkmCategories: builder.query<UmkmCategory[], void>({
      query: () => `bdc/umkm/categories`,
      providesTags: [{ type: 'UmkmCategory', id: 'LIST' }],
    }),
    getUmkmCategory: builder.query<UmkmCategory, string>({
      query: (id) => `bdc/umkm/category/${id}`,
    }),
    getUmkmList: builder.query<Umkm[], void>({
      query: () => `bdc/umkm/list`,
      providesTags: [{ type: 'Umkm', id: 'LIST' }],
    }),
    getUmkmDetail: builder.query<Umkm, string>({
      query: (id) => `bdc/umkm/detail/${id}`,
    }),
    getUmkmByCategory: builder.query<Umkm[], string>({
      query: (categoryId) => `bdc/umkm/category/${categoryId}/umkm`,
    }),
  }),
});

export const { useGetUmkmCategoriesQuery, useGetUmkmCategoryQuery, useGetUmkmListQuery, useGetUmkmDetailQuery, useGetUmkmByCategoryQuery } = umkmApi;
